/* Privé 2026 · comportamiento de las secciones propias */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const money = (cents, dec) => '$' + (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: dec ? 2 : 0, maximumFractionDigits: dec ? 2 : 0 });
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- Revelado al bajar ---------- */
  function reveals(root = document) {
    const els = $$('.pv-rv:not([data-rv])', root);
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) return els.forEach((e) => e.setAttribute('data-rv', '1'));
    const io = new IntersectionObserver((ents) => ents.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.remove('pv-pre'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    els.forEach((e) => {
      e.setAttribute('data-rv', '1');
      const r = e.getBoundingClientRect();
      if (r.top > innerHeight) { e.classList.add('pv-pre'); io.observe(e); }
    });
  }

  /* ---------- Encabezado ---------- */
  function header() {
    const wrap = $('[data-pv-header]');
    if (!wrap) return;
    const sec = wrap.closest('.shopify-section');
    const ann = $('.pv-ann', wrap);
    if (sec) { sec.style.position = 'sticky'; sec.style.top = ann ? `-${ann.offsetHeight}px` : '0px'; sec.style.zIndex = 40; }
    const box = $('[data-pv-megabox]', wrap);
    let t;
    const open = (i) => {
      if (!box) return;
      clearTimeout(t);
      $$('[data-pv-panel]', box).forEach((p) => p.classList.toggle('is-on', p.dataset.pvPanel === String(i)));
      $$('[data-pv-mega]', wrap).forEach((a) => a.classList.toggle('is-on', a.dataset.pvMega === String(i)));
      box.classList.add('is-open');
    };
    const close = () => { t = setTimeout(() => { box && box.classList.remove('is-open'); $$('[data-pv-mega]', wrap).forEach((a) => a.classList.remove('is-on')); }, 160); };
    $$('[data-pv-mega]', wrap).forEach((a) => {
      a.addEventListener('mouseenter', () => open(a.dataset.pvMega));
      a.addEventListener('focus', () => open(a.dataset.pvMega));
    });
    $('.pv-header', wrap).addEventListener('mouseleave', close);
    box && box.addEventListener('mouseenter', () => clearTimeout(t));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); closeMenu(); } });

    const menu = $('[data-pv-menu]'), scrim = $('[data-pv-scrim]'), openers = $$('[data-pv-open="menu"]');
    let opener = null;
    function openMenu(e) { opener = e && e.currentTarget; menu.classList.add('is-open'); scrim.classList.add('is-open'); openers.forEach((o) => o.setAttribute('aria-expanded', 'true')); document.body.style.overflow = 'hidden'; setTimeout(() => $('a', menu)?.focus(), 300); }
    function closeMenu() { if (!menu?.classList.contains('is-open')) return; menu.classList.remove('is-open'); scrim.classList.remove('is-open'); openers.forEach((o) => o.setAttribute('aria-expanded', 'false')); document.body.style.overflow = ''; opener && opener.focus(); }
    openers.forEach((o) => o.addEventListener('click', openMenu));
    const tabcart = $('[data-pv-tabcart]');
    tabcart && tabcart.addEventListener('click', (e) => { const d = document.querySelector('cart-drawer'); if (d && d.open) { e.preventDefault(); d.open(tabcart); } });
    scrim && scrim.addEventListener('click', closeMenu);
    $('[data-pv-close]', menu || document)?.addEventListener('click', closeMenu);
  }

  /* ---------- Vitrina ---------- */
  function hero() {
    $$('[data-pv-hero]').forEach((sc) => {
      const slides = $$('[data-pv-slide]', sc), dots = $$('[data-pv-dot]', sc);
      if (slides.length < 2) return;
      let i = 0, timer;
      const dur = parseFloat(sc.dataset.interval || 5.5) * 1000;
      const nameEl = $('[data-pv-nextname]', sc), imgEl = $('[data-pv-nextimg]', sc);
      function paintNext() {
        const n = slides[(i + 1) % slides.length];
        if (nameEl) nameEl.textContent = n.dataset.name.trim();
        const th = $('[data-pv-thumb]', n);
        if (imgEl && th) imgEl.src = th.textContent.trim();
      }
      function show(k) {
        slides[i].hidden = true;
        i = (k + slides.length) % slides.length;
        slides[i].hidden = false;
        $$('.pv-swap', slides[i]).forEach((e) => { e.style.animation = 'none'; e.offsetWidth; e.style.animation = ''; });
        dots.forEach((d, j) => { d.classList.toggle('is-on', j === i); d.classList.toggle('is-done', j < i); const b = d.querySelector('i'); b.style.animation = 'none'; b.offsetWidth; b.style.animation = ''; });
        paintNext(); arm();
      }
      function arm() { clearTimeout(timer); if (!reduce && !sc.classList.contains('is-paused')) timer = setTimeout(() => show(i + 1), dur); }
      dots.forEach((d) => d.addEventListener('click', () => show(+d.dataset.pvDot)));
      $$('[data-pv-next]', sc).forEach((b) => b.addEventListener('click', () => show(i + 1)));
      $$('[data-pv-prev]', sc).forEach((b) => b.addEventListener('click', () => show(i - 1)));
      sc.addEventListener('mouseenter', () => { sc.classList.add('is-paused'); clearTimeout(timer); });
      sc.addEventListener('mouseleave', () => { sc.classList.remove('is-paused'); arm(); });
      sc.addEventListener('focusin', () => { sc.classList.add('is-paused'); clearTimeout(timer); });
      let x0 = null;
      sc.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      sc.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 50) show(i + (dx < 0 ? 1 : -1)); x0 = null; });
      document.addEventListener('visibilitychange', () => (document.hidden ? clearTimeout(timer) : arm()));
      paintNext(); arm();
    });
  }

  /* ---------- Pestañas por género ---------- */
  function productTabs() {
    $$('[data-pv-products]').forEach((sec) => {
      const lim = +sec.dataset.limit || 8;
      const items = $$('.pv-card-li', sec);
      const rail = $('[data-pv-railbox].pv-rail', sec);
      $$('[data-pv-rail]', sec).forEach((b) => b.addEventListener('click', () => {
        if (!rail) return;
        const card = $('.pv-card-li:not([hidden])', rail);
        const step = card ? (card.getBoundingClientRect().width + 16) * 2 : 600;
        rail.scrollBy({ left: step * +b.dataset.pvRail, behavior: reduce ? 'auto' : 'smooth' });
      }));
      const apply = (g) => {
        let n = 0;
        items.forEach((li) => {
          const ok = g === 'all' || li.dataset.g === g || (g !== 'u' && li.dataset.g === 'u');
          const show = ok && n < lim;
          li.hidden = !show; if (show) n++;
        });
      };
      $$('.pv-tab', sec).forEach((b) => b.addEventListener('click', () => {
        $$('.pv-tab', sec).forEach((t) => t.setAttribute('aria-pressed', t === b));
        apply(b.dataset.g);
      }));
      apply('all');
    });
  }

  /* ---------- Comparador ---------- */
  function countUp(el) {
    const to = +el.dataset.pvCount;
    if (!to || reduce) return;
    const t0 = performance.now(), d = 1100;
    (function f(t) { const k = Math.min(1, (t - t0) / d), e = 1 - Math.pow(1 - k, 3); el.textContent = '$' + Math.round(to * e).toLocaleString('es-MX'); if (k < 1) requestAnimationFrame(f); })(t0);
  }
  function dupe() {
    $$('[data-pv-dupe]').forEach((sec) => {
      const pairs = $$('[data-pv-vs]', sec);
      $$('[data-pv-pair]', sec).forEach((b) => b.addEventListener('click', () => {
        $$('[data-pv-pair]', sec).forEach((t) => t.setAttribute('aria-pressed', t === b));
        pairs.forEach((p) => { p.hidden = p.dataset.pvVs !== b.dataset.pvPair; });
        const vis = pairs.find((p) => !p.hidden);
        vis && countUp($('[data-pv-count]', vis));
      }));
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((en) => { if (en[0].isIntersecting) { const v = pairs.find((p) => !p.hidden); v && countUp($('[data-pv-count]', v)); io.disconnect(); } }, { threshold: .4 });
        io.observe(sec);
      }
    });
  }

  /* ---------- Carrito (para el quiz y la barra fija) ---------- */
  async function addToCart(id, qty = 1, btn) {
    const drawer = document.querySelector('cart-drawer');
    btn && btn.setAttribute('aria-busy', 'true');
    try {
      const body = { items: [{ id, quantity: qty }] };
      if (drawer) { body.sections = drawer.getSectionsToRender().map((s) => s.id); body.sections_url = location.pathname; }
      const r = await fetch((window.routes?.cart_add_url || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const data = await r.json();
      if (data.status) throw new Error(data.description || data.message);
      if (drawer) { drawer.classList.remove('is-empty'); drawer.renderContents(data); }
      else location.href = window.routes?.cart_url || '/cart';
    } catch (e) {
      alert(e.message || 'No se pudo agregar. Intenta de nuevo.');
    } finally { btn && btn.removeAttribute('aria-busy'); }
  }

  async function buyNow(id, qty) {
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: qty }] }) });
      const d = await r.json();
      if (d.status) throw new Error(d.description || d.message);
      location.href = '/checkout';
    } catch (e) { alert(e.message || 'No se pudo continuar. Intenta de nuevo.'); }
  }

  /* ---------- Frasco que sigue al cursor ---------- */
  function tilt() {
    if (reduce || !matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    $$('[data-pv-hero]').forEach((box) => {
      box.addEventListener('mousemove', (e) => {
        const r = box.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        box.style.setProperty('--tx', (x * 18).toFixed(1) + 'px'); box.style.setProperty('--ty', (y * 12).toFixed(1) + 'px'); box.style.setProperty('--rz', (x * 4).toFixed(2) + 'deg');
      });
      box.addEventListener('mouseleave', () => { box.style.setProperty('--tx', '0px'); box.style.setProperty('--ty', '0px'); box.style.setProperty('--rz', '0deg'); });
    });
  }

  /* ---------- Ficha ---------- */
  const TIER_RX = {
    salida: /(?:notas?\s+(?:de\s+)?)?salida\s*(?:son|es)?\s*:?\s*([\s\S]+?)(?=(?:;|\.|\n)?\s*(?:las\s+)?(?:notas?\s+(?:de\s+)?)?coraz[oó]n|$)/i,
    corazon: /coraz[oó]n\s*(?:son|es)?\s*:?\s*([\s\S]+?)(?=(?:;|\.|\n)?\s*(?:las\s+)?(?:notas?\s+(?:de\s+)?)?(?:fondo|base)\b|$)/i,
    fondo: /(?:fondo|base)\s*(?:son|es)?\s*:?\s*([\s\S]+?)(?=\n\s*\n|\.\s|$)/i,
  };
  function cleanNotes(s) {
    if (!s) return [];
    s = s.split(/\n/)[0].replace(/\([^)]*\)/g, '').replace(/[•·|]/g, ',');
    s = s.split(/[.;]\s/)[0];
    return s.split(/,|\sy\s|\se\s/).map((x) => x.replace(/[^\p{L}\s'-]/gu, '').trim()).filter((x) => x.length > 1 && x.length < 28 && x.split(' ').length <= 4)
      .slice(0, 6).map((x) => x.charAt(0).toUpperCase() + x.slice(1).toLowerCase());
  }
  function pdp() {
    const root = $('[data-pv-pdp]');
    if (!root) return;
    const msi = +root.dataset.msi || 0;
    const stage = $('[data-pv-stage]', root);
    const mainImg = () => $('img', stage);

    $$('[data-pv-thumb]', root).forEach((b) => b.addEventListener('click', () => {
      const im = mainImg(); if (!im) return;
      im.removeAttribute('srcset'); im.src = b.dataset.pvThumb;
      $$('[data-pv-thumb]', root).forEach((t) => t.setAttribute('aria-current', t === b));
    }));

    // Precio por ml (solo si el tamaño trae ml)
    const permlEl = $('[data-pv-perml]', root);
    const perml = (price, size) => {
      if (!permlEl) return;
      const m = /(\d+(?:[.,]\d+)?)\s*ml\b/i.exec(size || '');
      const ml = m ? parseFloat(m[1].replace(',', '.')) : 0;
      if (!ml || !price || /\bset\b|\bpz/i.test(size)) { permlEl.hidden = true; return; }
      const v = price / 100 / ml;
      permlEl.textContent = `$${v.toLocaleString('es-MX', { maximumFractionDigits: v < 10 ? 1 : 0 })} por ml`;
      permlEl.hidden = false;
    };
    if (permlEl) {
      const sel = $('[data-pv-variant][aria-pressed="true"]', root);
      perml(sel ? JSON.parse(sel.dataset.pvVariant).price : Math.round(parseFloat((($('[data-pv-price]', root) || {}).textContent || '0').replace(/[^\d.]/g, '')) * 100), sel ? sel.dataset.size + ' ' : permlEl.dataset.size);
    }
    // Reseñas de Loox: la sección se muestra solo cuando el widget trae reseñas
    const rev = $('[data-pv-reviews]');
    if (rev) {
      const check = () => { if ($('.jdgm-rev', rev)) { rev.classList.add('is-on'); return true; } return false; };
      check();
      const mo = new MutationObserver(() => { if (check()) mo.disconnect(); });
      mo.observe(rev, { subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'height'] });
      setTimeout(() => mo.disconnect(), 20000);
    }
    const vid = $('[data-pv-vid]', root), add = $('[data-pv-add]', root);
    const priceEl = $('[data-pv-price]', root), cmpEl = $('[data-pv-compare]', root), offEl = $('[data-pv-off]', root), msiEl = $('[data-pv-msi]', root);
    $$('[data-pv-variant]', root).forEach((b) => b.addEventListener('click', () => {
      const v = JSON.parse(b.dataset.pvVariant);
      $$('[data-pv-variant]', root).forEach((t) => t.setAttribute('aria-pressed', t === b));
      vid.value = v.id;
      priceEl.textContent = money(v.price);
      perml(v.price, b.dataset.size);
      let off = v.compare > v.price ? Math.round((1 - v.price / v.compare) * 100) : 0; if (off > 60 || off < 5) off = 0;
      cmpEl.hidden = offEl.hidden = !off;
      if (off) { cmpEl.textContent = money(v.compare); offEl.textContent = `-${off}%`; }
      if (msiEl && msi) msiEl.textContent = `${msi} MSI de ${money(Math.floor(v.price / msi), true)}`;
      const sp = $('[data-pv-sticky-price]'); if (sp) sp.textContent = money(v.price) + (msi ? ` · ${msi} MSI de ${money(Math.floor(v.price / msi), true)}` : '');
      add.disabled = !v.available || !v.price;
      add.querySelector('span').textContent = v.available && v.price ? 'Agrega a tu bolsa' : 'Agotado';
      const st = $('[data-pv-stocktxt]', root); if (st && v.inv != null) st.textContent = v.inv > 0 ? `Quedan ${v.inv}` : 'Sin piezas';
      if (v.media) { const t = $(`[data-media-id="${v.media}"]`, root); t && t.click(); }
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    }));

    const qin = $('[data-pv-qtyin]', root);
    $('[data-pv-buynow]', root)?.addEventListener('click', () => buyNow(+vid.value, +qin.value || 1));
    $$('[data-pv-qty]', root).forEach((b) => b.addEventListener('click', () => { qin.value = Math.max(1, Math.min(10, (+qin.value || 1) + +b.dataset.pvQty)); }));

    // Notas desde la descripción si no hay metacampos
    const pyr = $('[data-pv-pyr]', root), desc = $('[data-pv-desc]', root);
    if (pyr && pyr.dataset.parse && desc) {
      const ta = document.createElement('textarea');
      ta.innerHTML = desc.innerHTML.replace(/<(br|\/p|\/li|\/div|\/h\d)[^>]*>/gi, '\n').replace(/<[^>]+>/g, ' ');
      const txt = ta.value.replace(/\u00a0/g, ' ').replace(/[ \t]+/g, ' ');
      const res = {};
      ['salida', 'corazon', 'fondo'].forEach((k) => { const m = txt.match(TIER_RX[k]); res[k] = cleanNotes(m && m[1]); });
      const found = Object.values(res).filter((a) => a.length).length;
      if (found >= 2) Object.entries(res).forEach(([k, notes]) => {
        if (!notes.length) return;
        const row = $(`[data-tier="${k}"]`, pyr);
        $('.pv-tier__notes', row).innerHTML = notes.map((n) => `<a class="pv-note" href="/search?type=product&q=${encodeURIComponent(n)}">${esc(n)}</a>`).join('');
        row.hidden = false;
      });
      if (found < 2) { const prof = $('[data-pv-profile]', root); const fam = $('.pv-famline span', prof); if (!fam && !$('.pv-when', prof)) prof.hidden = true; }
    }

    // Entrega
    const eta = $('[data-pv-eta]', root);
    if (eta) {
      const cut = +eta.dataset.cutoff || 15, tz = eta.dataset.tz || 'America/Monterrey', city = eta.dataset.city;
      const tick = () => {
        const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', { timeZone: tz, hour12: false, hour: 'numeric', minute: 'numeric', second: 'numeric', weekday: 'short' }).formatToParts(new Date()).map((p) => [p.type, p.value]));
        const h = +parts.hour % 24, m = +parts.minute, s = +parts.second, sunday = parts.weekday === 'Sun';
        const left = cut * 3600 - (h * 3600 + m * 60 + s);
        if (left > 0 && !sunday) {
          const hh = Math.floor(left / 3600), mm = Math.floor((left % 3600) / 60), ss = left % 60;
          eta.innerHTML = `Pide en <span class="pv-cd">${hh} h ${String(mm).padStart(2, '0')} min ${String(ss).padStart(2, '0')} s</span> y <b>recíbelo hoy</b> en ${esc(city)}.`;
        } else {
          eta.innerHTML = `Pide hoy y <b>recíbelo el siguiente día hábil</b> en ${esc(city)}.`;
        }
      };
      tick(); setInterval(tick, 1000);
    }

    // Barra fija
    const sticky = $('[data-pv-sticky]');
    if (sticky && add && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-show', show); sticky.setAttribute('aria-hidden', String(!show));
        $('[data-pv-sticky-add]', sticky).tabIndex = show ? 0 : -1;
        document.body.classList.toggle('pv-sb-on', show && innerWidth < 990);
      });
      io.observe(add);
      $('[data-pv-sticky-add]', sticky).addEventListener('click', (e) => addToCart(+vid.value, +qin.value || 1, e.currentTarget));
      $('[data-pv-sticky-now]', sticky)?.addEventListener('click', () => buyNow(+vid.value, +qin.value || 1));
    }
  }

  /* ---------- WhatsApp ---------- */
  function wa() {
    const b = $('[data-pv-wa-bubble]');
    if (!b) return;
    let seen = false;
    try { seen = sessionStorage.getItem('pvWaSeen') === '1'; } catch (e) {}
    if (seen) return;
    setTimeout(() => { b.classList.add('is-show'); setTimeout(() => b.classList.remove('is-show'), 6000); try { sessionStorage.setItem('pvWaSeen', '1'); } catch (e) {} }, 9000);
  }

  /* ---------- Quiz ---------- */
  const QS = [
    { k: 'g', t: '¿Para quién es?', o: [['h', 'Para él', 'Hombre'], ['m', 'Para ella', 'Mujer'], ['u', 'Me da igual', 'Unisex o para regalar']] },
    { k: 'fam', t: '¿Qué aroma te atrae más?', o: [['gourmand', 'Dulce', 'Vainilla, café, caramelo'], ['fresco', 'Fresco y limpio', 'Cítricos, acuático'], ['amaderado', 'Amaderado', 'Elegante, seco, maderas'], ['floral', 'Floral', 'Flores, suave'], ['especiado', 'Especiado', 'Pimienta, canela, cálido'], ['ambar', 'Ámbar y oriental', 'Resinas, oud, intenso']] },
    { k: 'when', t: '¿Cuándo lo vas a usar?', o: [['dia', 'Todos los días', 'Oficina, escuela, diario'], ['noche', 'En la noche', 'Cenas, salidas, citas'], ['especial', 'Ocasiones especiales', 'Bodas, eventos, regalo']] },
    { k: 'b', t: '¿Cuánto quieres invertir?', o: [['1', 'Hasta $1,500', 'Lo mejor de los árabes'], ['2', '$1,500 a $4,000', 'Diseñador y árabes premium'], ['3', 'Sin límite', 'Quiero lo mejor de lo mejor']] },
  ];
  const KW = {
    gourmand: ['vainilla', 'caramelo', 'café', 'cafe', 'chocolate', 'cacao', 'praliné', 'praline', 'haba tonka', 'miel', 'azúcar', 'malvavisco', 'almendra', 'canela', 'dulce'],
    fresco: ['bergamota', 'limón', 'limon', 'cítric', 'citric', 'marin', 'acuátic', 'acuatic', 'menta', 'mandarina', 'toronja', 'pomelo', 'lima', 'fresc', 'neroli', 'verde'],
    amaderado: ['cedro', 'sándalo', 'sandalo', 'vetiver', 'pachulí', 'pachuli', 'madera', 'amaderad', 'musgo', 'abedul', 'cuero', 'guayaco'],
    floral: ['rosa', 'jazmín', 'jazmin', 'peonía', 'peonia', 'magnolia', 'iris', 'nardo', 'flor', 'gardenia', 'lirio', 'azahar', 'violeta', 'orquídea'],
    especiado: ['pimienta', 'canela', 'cardamomo', 'azafrán', 'azafran', 'clavo', 'jengibre', 'nuez moscada', 'especia', 'especiad'],
    ambar: ['ámbar', 'ambar', 'oud', 'incienso', 'resina', 'benjuí', 'labdan', 'almizcle', 'oriental', 'mirra', 'tabaco'],
  };
  const NEAR = { gourmand: ['ambar', 'especiado'], ambar: ['gourmand', 'especiado'], especiado: ['ambar', 'gourmand'], amaderado: ['fresco', 'especiado'], fresco: ['amaderado'], floral: ['gourmand', 'fresco'] };
  const WHEN = { dia: ['fresco', 'floral', 'amaderado'], noche: ['gourmand', 'ambar', 'especiado'], especial: ['ambar', 'floral', 'gourmand'] };

  function quiz() {
    const root = $('[data-pv-quiz]');
    if (!root) return;
    const box = $('[data-pv-quiz-box]', root);
    const msi = +root.dataset.msi || 0;
    const norm = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    const AR = root.dataset.arabes.split(',').map(norm).filter(Boolean);
    const NI = root.dataset.nicho.split(',').map(norm).filter(Boolean);
    let catalog = null, loading = null;
    const ans = {}; let step = 0;

    function load() {
      if (loading) return loading;
      loading = (async () => {
        const all = [];
        for (let page = 1; page <= 6; page++) {
          const r = await fetch(`/products.json?limit=250&page=${page}`);
          const d = await r.json();
          all.push(...d.products);
          if (d.products.length < 250) break;
        }
        catalog = all.map((p) => {
          const v = p.variants.find((x) => x.available) || p.variants[0];
          const vn = norm(p.vendor), tn = norm(p.title), tp = norm(p.product_type);
          const hit = (list) => list.some((b) => vn === b || (b.length > 3 && tn.includes(b)));
          const world = hit(NI) ? 'nicho' : hit(AR) ? 'arabes' : 'disenador';
          const g = tp.includes('unisex') || tn.includes('unisex') ? 'u' : (tp.includes('mujer') || tp.includes('dama') || tn.includes('para mujer') || tn.includes('dama')) ? 'm' : (tp.includes('hombre') || tn.includes('hombre') || tn.includes('caballero')) ? 'h' : '';
          const body = (p.body_html || '').replace(/<[^>]+>/g, ' ').toLowerCase();
          const fams = {};
          for (const [k, ws] of Object.entries(KW)) fams[k] = ws.reduce((n, w) => n + (body.includes(w) ? 1 : 0), 0);
          return { p, v, world, g, fams, price: Math.round(parseFloat(v.price) * 100), img: p.images[0]?.src, avail: p.variants.some((x) => x.available) };
        }).filter((x) => x.avail && x.price > 0 && x.img && !/vestido|vela|candle/i.test(x.p.title));
        return catalog;
      })();
      return loading;
    }

    function score(x) {
      let s = 0;
      if (ans.g === 'u') s += x.g === 'u' ? 3 : 1; else if (x.g === ans.g) s += 4; else if (x.g === 'u') s += 2; else if (x.g) s -= 6;
      s += Math.min(x.fams[ans.fam], 4) * 2.2;
      (NEAR[ans.fam] || []).forEach((n) => { s += Math.min(x.fams[n], 3) * .6; });
      (WHEN[ans.when] || []).forEach((n) => { s += Math.min(x.fams[n], 3) * .5; });
      const P = x.price / 100;
      if (ans.b === '1') s += P <= 1500 ? 2 : P <= 2200 ? -2 : -8;
      if (ans.b === '2') s += P >= 1300 && P <= 4000 ? 2 : P < 1300 ? 0 : -5;
      if (ans.b === '3') s += P >= 3000 ? 2 : 0;
      return s;
    }
    const WN = { arabes: 'Árabes', disenador: 'Diseñador', nicho: 'Nicho' };
    const WHY = {
      arabes: 'La opción intensa y duradera por menos.',
      disenador: 'Un clásico de firma que nunca falla.',
      nicho: 'Perfumería de autor para no oler a nadie más.',
    };

    function cardHTML(r) {
      const x = r.x, p = x.p, cmp = Math.round(parseFloat(x.v.compare_at_price || 0) * 100);
      const vend = /priv/i.test(p.vendor) ? '' : p.vendor;
      const name = p.title.replace(/^perfume\s+(para\s+(hombre|mujer|dama|caballero)\s+|unisex\s+|de\s+(hombre|dama|caballero)\s+)?/i, '');
      const off = cmp > x.price && cmp < x.price * 2.5;
      return `<article class="pv-card">
        <a class="pv-card__media" href="/products/${p.handle}"><span class="pv-badge">${r.pct}% afinidad</span><img src="${x.img}${x.img.includes('?') ? '&' : '?'}width=500" alt="${esc(p.title)}" loading="lazy"></a>
        <div class="pv-card__body"><p class="pv-qworld">${WN[x.world]}</p>${vend ? `<p class="pv-card__meta">${esc(vend)}</p>` : ''}
          <h3 class="pv-card__name"><a href="/products/${p.handle}">${esc(name)}</a></h3>
          <p class="pv-qwhy">${WHY[x.world]}</p></div>
        <div class="pv-card__buy"><div class="pv-card__pricebox"><p class="pv-card__price"><b class="pv-money">${money(x.price)}</b>${off ? `<s>${money(cmp)}</s>` : ''}</p>
          ${msi ? `<p class="pv-card__msi">o ${msi} MSI de ${money(Math.floor(x.price / msi), true)}</p>` : ''}</div>
          <button class="pv-card__add" type="button" data-pv-qadd="${x.v.id}" aria-label="Agrega ${esc(name)} a tu bolsa"><svg class="pv-card__bag" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8h14l-1.2 12H6.2z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg><span>Agrega</span></button></div></article>`;
    }

    function render() {
      const prog = `<div class="pv-qprog">${QS.map((q, i) => `<i class="${i < step ? 'is-done' : ''}"></i>`).join('')}</div>`;
      if (step < QS.length) {
        const q = QS[step];
        box.innerHTML = prog + `<div class="pv-qstep"><p class="pv-eyebrow">Pregunta ${step + 1} de ${QS.length}</p><h2 class="pv-display">${q.t}</h2>
          <div class="pv-qopts">${q.o.map((o) => `<button class="pv-qopt" type="button" data-a="${o[0]}"><b>${o[1]}</b><span>${o[2]}</span></button>`).join('')}</div>
          ${step ? '<button class="pv-qback" type="button" data-back>← Regresar</button>' : ''}</div>`;
        $('.pv-qopt', box)?.focus({ preventScroll: true });
        return;
      }
      box.innerHTML = prog + '<p class="pv-qloading">Buscando entre todo el catálogo…</p>';
      load().then(() => {
        const scored = catalog.map((x) => ({ x, s: score(x) })).sort((a, b) => b.s - a.s);
        const top = scored[0]?.s || 1;
        let picks = ['arabes', 'disenador', 'nicho'].map((w) => scored.find((r) => r.x.world === w)).filter(Boolean);
        if (ans.b === '1') picks = picks.filter((r) => r.x.price <= 220000);
        if (picks.length < 3) scored.forEach((r) => { if (picks.length < 3 && !picks.includes(r)) picks.push(r); });
        picks = picks.slice(0, 3).map((r) => ({ ...r, pct: Math.max(68, Math.min(97, Math.round(97 - (top - r.s) * 3))) }));
        const wa = root.dataset.wa;
        box.innerHTML = `<div class="pv-qprog">${QS.map(() => '<i class="is-done"></i>').join('')}</div><div class="pv-qstep"><p class="pv-eyebrow">Tu resultado</p><h2 class="pv-display">Tus tres <em>firmas.</em></h2>
          <div class="pv-qres">${picks.map(cardHTML).join('')}</div>
          <div style="display:flex;gap:10px;flex-wrap:wrap;margin-top:24px"><button class="pv-textlink" type="button" data-reset>Repite el quiz</button>
          ${wa ? `<a class="pv-btn pv-btn--wa" target="_blank" rel="noopener" href="https://wa.me/${wa}?text=${encodeURIComponent('Hola, hice el quiz y quiero asesoría')}">Habla con un asesor</a>` : ''}</div></div>`;
      }).catch(() => { box.innerHTML = '<p class="pv-qloading">No pudimos cargar el catálogo. Intenta de nuevo o escríbenos por WhatsApp.</p>'; });
    }
    box.addEventListener('click', (e) => {
      const a = e.target.closest('[data-a]');
      if (a) { ans[QS[step].k] = a.dataset.a; step++; if (step === QS.length - 1) load(); render(); return; }
      if (e.target.closest('[data-back]')) { step = Math.max(0, step - 1); render(); return; }
      if (e.target.closest('[data-reset]')) { step = 0; render(); return; }
      const add = e.target.closest('[data-pv-qadd]');
      if (add) addToCart(+add.dataset.pvQadd, 1, add);
    });
    render();
  }

  function init() { header(); hero(); tilt(); productTabs(); dupe(); pdp(); wa(); quiz(); reveals(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', (e) => { hero(); productTabs(); dupe(); reveals(e.target); });
})();
